import { render, staticRenderFns } from "./AccountSettingModuleConfig.vue?vue&type=template&id=135530b3&scoped=true&"
import script from "./AccountSettingModuleConfig.vue?vue&type=script&lang=js&"
export * from "./AccountSettingModuleConfig.vue?vue&type=script&lang=js&"
import style0 from "./AccountSettingModuleConfig.vue?vue&type=style&index=0&id=135530b3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135530b3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('135530b3')) {
      api.createRecord('135530b3', component.options)
    } else {
      api.reload('135530b3', component.options)
    }
    module.hot.accept("./AccountSettingModuleConfig.vue?vue&type=template&id=135530b3&scoped=true&", function () {
      api.rerender('135530b3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/AccountSettingModuleConfig.vue"
export default component.exports